<template>
  <div class="content">
   <component v-bind:is="layout"></component>
    
  </div>
</template>

<script>
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';
export default {
    name: 'directContentDetail',
    components:{
      
    },
    computed: {
    layout () { 
      const themename = 'ThemeMDB'
      return () => import('@/components/'+themename+'/directContentDetail')
    }
  }

};
</script>
